import axios from "axios";
import { apiUrl } from "../../dataProvider";

export const PENDING_VIDEO_VALUE = "__pending__";

const buildS3FormData = (fields, file) => {
  const formData = new FormData();
  Object.keys(fields).forEach(key => formData.append(key, fields[key]));
  formData.append("file", file);
  return formData;
};

const postFormDataToS3 = (url, formData, onProgress) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);

    if (onProgress) {
      xhr.upload.onprogress = event => {
        if (event.lengthComputable) {
          onProgress(Math.round((event.loaded * 100) / event.total));
        }
      };
    }

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
        return;
      }

      reject(new Error(xhr.responseText || `S3 upload failed (${xhr.status})`));
    };

    xhr.onerror = () => {
      reject(new Error("Network error during S3 upload"));
    };

    xhr.send(formData);
  });

export const getUploadErrorMessage = error => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (typeof error?.message === "string" && error.message) {
    return error.message;
  }

  if (typeof error?.response?.data === "string") {
    const match = error.response.data.match(/<Message>([^<]+)<\/Message>/);
    if (match) return match[1];
  }

  return "Video upload failed. Please try again.";
};

export const uploadTrainingVideoToS3 = async (file, onProgress) => {
  if (!(file instanceof File)) {
    throw new Error("Invalid video file. Please choose the video again.");
  }

  const { data: presigned } = await axios.post(
    `${apiUrl}/training-videos/generate-presigned-url`,
    { filename: file.name }
  );

  const { url, fields, key } = presigned || {};

  if (!url || !fields || !key) {
    throw new Error("Could not prepare video upload. Please try again.");
  }

  await postFormDataToS3(url, buildS3FormData(fields, file), onProgress);

  return key;
};

export const VIDEO_UPLOAD_SOURCES = [
  "video_file_path",
  "vietnamese_video_file_path",
];
